import {SecurityClientConfig} from "./typing";
import {AuthenticationManager} from "./authenticationManager";


export class SecurityClient<TPrincipal = unknown> {

    authenticationManager: AuthenticationManager<TPrincipal>;

    constructor(config: SecurityClientConfig<TPrincipal> = {}) {
        const {
            initialPrincipal,
            onSuccess,
            onReset,
            onSettled,
        } = config;
        this.authenticationManager = new AuthenticationManager<TPrincipal>({
            initialPrincipal,
            onReset,
            onSettled,
            onSuccess,
        });
    }



    isAuthenticated() {
        return this.authenticationManager.isAuthenticated()
    }

    /**
     * 不要随意invalid
     * 应该是操作 才进行invalidate,
     *
     * 例如: 接口响应后直接invalidate 导致SecuredBoundary 整体状态树重置了  不能达到局部状态范围重置效果
     */
    invalidate(): void {
        this.authenticationManager.invalidate();
    }

    mount(): void {
    }
    unmount(): void {

    }
}